/**
 *
 * This file was automatically generated using build-icons npm script and should not be edited
 *
 **/
import { createIcon } from "@cmp-src/icons/create-icon";
export const FavoriteIcon = createIcon({
  displayName: "FavoriteIcon",
  viewBox: "0 0 14 15",
  path: (
    <g fill="none" stroke="currentColor" strokeWidth={1.5}>
      <path
        d="M2.75 13.25V2.75C2.75 1.64543 3.64543 0.75 4.75 0.75H9.25C10.3546 0.75 11.25 1.64543 11.25 2.75V13.25L7 11.1797L2.75 13.25Z"
        stroke="currentColor"
        strokeWidth={1.5}
      />
    </g>
  )
});
